
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcRouter as ObcRouterElement} from '@oicl/openbridge-webcomponents/dist/automation/router/router.js';
 
 
 

 
 export const ObcRouter = createComponent({
   react: React,
   tagName: 'obc-router',
   elementClass: ObcRouterElement,
   events: {
     
   }
  });
 
 